import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CheckAccessToken } from '@mdd/api';
import { PrincipalService } from '../principal.service';
import { createRouterLocation } from './createRouterLocation';

@Injectable()
export class ForceLogoutGuard {
    private checkAccessToken = new CheckAccessToken();

    constructor(
        private router: Router,
        private principal: PrincipalService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (this.checkAccessToken.execute(createRouterLocation(route, this.router))) {
            // User is signed in, but this route does not allow them. Log them out
            // but do not redirect them to the login page
            this.principal.logout({}, true);
        }

        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot): boolean {
        return this.canActivate(route);
    }
}
